import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import IntegrationDataService from "../../../../../services/IntegrationDataService";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { componentKey, setLoadingState, setOrganizationDetails, setFormAndTaxYearList, setImportData, setIsImportDataGridViewLoaded, setFormSettings } from "./BillSlice";
import { BILL_LOADING_STATES } from "../constants";
import FormsDataService from "../../../../../services/FormsDataService";
export const { getOrganization, getFormAndTaxYearList, getLoadImportData, getFormSetting, getBillOrgDetailsByUser} = {

    getOrganization: (payload) => {
        return {
            type: "BILL/GET_ORGANIZATION",
            payload: payload
        }
    },
    getFormAndTaxYearList: (payload) => {
        return {
            type: "BILL/GET_FORMS_TAXTEAR_LIST",
            payload: payload
        }
    },
    getLoadImportData: (payload) => {
        return {
            type: "BILL/GET_LOAD_IMPORT_DATA",
            payload: payload
        }
    },
    getFormSetting: (payload) => {
        return {
            type: "BILL/GET_FORM_SETTING",
            payload: payload
        }
    },
    getBillOrgDetailsByUser: (payload) => {
        return {
            type: "BILL/GET_BILLORGANIZATION_BYUSER",
            payload: payload
        }
    },
}

function* getOrganizationAsync(action) {
    try {
        yield put(setLoadingState({ state: BILL_LOADING_STATES.PAGE_LOADING }));
        const { billModel } = action.payload;
        const response = yield IntegrationDataService.getOrganizations(billModel);
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if (response?.data?.Data) {
                yield put(setOrganizationDetails(response?.data?.Data));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to fetch Organization Details",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Organization Details", message: "Ran into an error, please try again later or contact support" }));
    }
    finally {
        yield put(setLoadingState({ state: BILL_LOADING_STATES.PAGE_DATA_READY }));
    }
}

function* getFormAndTaxYearListAsync() {
    try {
        const response = yield IntegrationDataService.getTaxYearFormTypes();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if (response?.data?.Data) {
                yield put(setFormAndTaxYearList(response?.data?.Data));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to fetch Form and Tax Year Details",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }

        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({
            heading: "Failed to fetch TaxYear And Form Types",
            message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.",
            variant: TOASTER_VARIANT.DANGER
        }));
    }
}

function* getLoadImportDataAsync(action) {
    try {
        yield put(setLoadingState({ state: BILL_LOADING_STATES.PAGE_LOADING }));
        const { integrationImportRequestDto } = action.payload;
        const response = yield IntegrationDataService.getIntegrationImportData(integrationImportRequestDto);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
            yield put(setLoadingState({state: BILL_LOADING_STATES.PAGE_DATA_READY }));
        }
        else if (response?.data?.Status == 1) {
            if (response?.data?.Data) {
                yield put(setImportData(response?.data?.Data));
                yield put(setIsImportDataGridViewLoaded(true));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to fetch Import Data Details",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({
            heading: "Failed to fetch Import Data",
            message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.",
            variant: TOASTER_VARIANT.DANGER
        }));
    }
}

function* getFormSettingAsync(action) {
    try {
        const { formId, year } = action.payload;
        const response = yield FormsDataService.getFormSetting(formId, year);

        if (response?.data?.Status === 1) {
            if (response?.data?.Data) {
                yield put(setFormSettings(response?.data?.Data));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to fetch Form Details",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
        else {
            yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({
            heading: "Error",
            message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.",
            variant: TOASTER_VARIANT.DANGER
        }));
    }
}

function* getBillOrgDetailsByUserAsync() {
    try {
        yield put(setLoadingState({ state: BILL_LOADING_STATES.PAGE_LOADING }));
        const response = yield IntegrationDataService.getBillOrgDetailsByUser();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if (response?.data?.Data) {
                yield put(setOrganizationDetails(response?.data?.Data));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to fetch bill organization Details",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Organization Details", message: "Ran into an error, please try again later or contact support" }));
    }
    finally{
         yield put(setLoadingState({ state: BILL_LOADING_STATES.PAGE_DATA_READY }));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getOrganization().type, getOrganizationAsync),
        takeLatest(getFormAndTaxYearList().type, getFormAndTaxYearListAsync),
        takeLatest(getLoadImportData().type, getLoadImportDataAsync),
        takeLatest(getBillOrgDetailsByUser().type, getBillOrgDetailsByUserAsync),
        takeLatest(getFormSetting().type, getFormSettingAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);